import React from "react";
import { func, string } from "prop-types";
import { AreaInput } from "../ui/AreaInput";

export default function AddCommentArea(props) {
  const { userAvatar } = props;

  return (
    <div className="comments-component__comment-add">
      <AreaInput
        userAvatar={userAvatar}
        handleSubmit={props.createComment}
        name="comment"
        placeholder="Написать комментарий..."
        btnText="Отправить"
      />
    </div>
  );
}

AddCommentArea.propTypes = {
  userAvatar: string.isRequired,
  createComment: func.isRequired,
};
